import axios from "../http";

let module = "/follow";

function addFollowRecord(data) {
    return axios.post(module, data);
}

function queryClewFollowRecordByClewId(data) {
    return axios.get(module+"/"+data.id);
}
export default {
    addFollowRecord,
    queryClewFollowRecordByClewId,
}
